/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const HaccpProducts = lazy(
  () => import("@/pages/haccp/products/HaccpProducts"),
);
const HaccpProductsLayout = lazy(
  () => import("@/pages/haccp/products/HaccpProductsLayout"),
);
const HaccpListProductView = lazy(
  () => import("@/pages/haccp/products/components/list/HaccpListProductView"),
);
const HaccpProductDetailView = lazy(
  () =>
    import("@/pages/haccp/products/components/detail/HaccpProductDetailView"),
);

export const productsRoutes: RouteObject[] = [
  {
    path: "/haccp/products",
    element: <HaccpProducts />,
    children: [
      {
        path: "domain/:domainId/site/:siteId",
        element: <HaccpProductsLayout />,
        children: [
          {
            path: "",
            element: <HaccpListProductView />,
          },
          {
            path: "product/:productId",
            element: <HaccpProductDetailView />,
          },
        ],
      },
    ],
  },
];
